import { doFetch } from "./doFetch";

export async function tryDoFetch(url, body, method = "POST", onError, headers) {
  try {
    return await doFetch(url, body, method, headers);
  } catch (err) {
    console.error("Fetch exception: ", { name: err?.toString(), body, method, url });
    if (onError) onError(err);
  }
}
